/* Custom code Yabang */
(() => {
  const WRAPPER_SEL = '.logo-block__image-wrapper';
  const IMG_SEL     = '.logo-block__image';

  const PART_SELECTORS = [
    ':scope > g',
    ':scope > path',
    ':scope > rect',
    ':scope > circle',
    ':scope > polygon',
    ':scope > polyline',
    ':scope > ellipse',
    ':scope > use'
  ].join(',');

  function getImageURL(img){
    return img.currentSrc || img.src || img.getAttribute('data-src') || img.getAttribute('data-original');
  }

  function markWhole(svg){
    svg.classList.add('stagger-whole');
  }

  async function inlineOne(wrapper){
    const img = wrapper.querySelector(IMG_SEL);
    if(!img) return;

    const url = getImageURL(img);
    if(!url || !/\.svg(\?|$)/i.test(url)){
      img.classList.add('stagger-fallback');
      return;
    }

    try{
      const res = await fetch(url, { cache: 'force-cache', mode: 'cors' });
      if(!res.ok) throw new Error(`HTTP ${res.status}`);
      const text = await res.text();

      const doc = new DOMParser().parseFromString(text, 'image/svg+xml');
      const svg = doc.querySelector('svg');
      if(!svg) throw new Error('No <svg> root');

      svg.classList.add('stagger-svg','logo-block__image');

      const alt = img.getAttribute('alt');
      if(alt && !svg.hasAttribute('aria-label')){
        svg.setAttribute('role', 'img');
        svg.setAttribute('aria-label', alt);
      }

      svg.removeAttribute('width');
      svg.removeAttribute('height');
      svg.setAttribute('preserveAspectRatio','xMidYMid meet');

      let needBBoxViewBox = !svg.hasAttribute('viewBox');

      if(needBBoxViewBox){
        img.insertAdjacentElement('beforebegin', svg);
        try{
          const bbox = svg.getBBox();
          if (bbox && isFinite(bbox.x) && isFinite(bbox.y) && bbox.width > 0 && bbox.height > 0){
            const padX = Math.max(1, bbox.width * 0.02);
            const padY = Math.max(1, bbox.height * 0.02);
            const x = bbox.x - padX;
            const y = bbox.y - padY;
            const w = bbox.width  + padX*2;
            const h = bbox.height + padY*2;
            svg.setAttribute('viewBox', `${x} ${y} ${w} ${h}`);
          }
        } catch(_) {}
        img.remove();
      } else {
        img.replaceWith(svg);
      }

      if (svg.parentNode !== wrapper){
        img.replaceWith(svg);
      }

      let parts = svg.querySelectorAll(PART_SELECTORS);
      if(!parts.length){
        parts = svg.querySelectorAll('g,path,rect,circle,polygon,polyline,ellipse,use');
      }

      if(parts.length <= 1){
        markWhole(svg);
      } else {
        parts.forEach((el, i) => {
          el.setAttribute('data-stagger', '');
          el.style.setProperty('--i', i.toString());
        });
      }

      svg.addEventListener('click', () => { window.location.href = '/'; });

      requestAnimationFrame(() => svg.classList.add('yb-ready'));
    } catch (e){
      const img2 = wrapper.querySelector(IMG_SEL);
      if(img2){
        img2.classList.add('stagger-fallback');
        img2.addEventListener('click', () => { window.location.href = '/'; });
      }
    }
  }

  async function inlineAll(root = document){
    const wrappers = root.querySelectorAll(WRAPPER_SEL);
    await Promise.all(Array.from(wrappers).map(inlineOne));
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', () => inlineAll());
  } else {
    inlineAll();
  }

  document.addEventListener('shopify:section:load', (e) => inlineAll(e.target));
  document.addEventListener('shopify:section:select', (e) => inlineAll(e.target));

  const mo = new MutationObserver((mutations) => {
    for(const m of mutations){
      if(m.type === 'childList'){
        m.addedNodes.forEach(node => {
          if(node.nodeType === 1){
            if(node.matches?.(WRAPPER_SEL)) inlineAll(node);
            else if(node.querySelector?.(WRAPPER_SEL)) inlineAll(node);
          }
        });
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();